// Presentational card for a single schedule. Entities own no state
// and make no API calls (see react-rewrite-plan §5.2). Callers pass a
// fully-mapped ScheduleView.

import { Badge } from '@/shared/ui/badge';
import type { ScheduleView } from '../model/types';

type ScheduleCardProps = {
  schedule: ScheduleView;
};

function formatNextRun(value: string | undefined): string {
  if (!value) return 'Not scheduled';
  return `Next run: ${value}`;
}

function formatCron(value: string | null): string {
  return value ?? 'One-time schedule';
}

export function ScheduleCard({ schedule }: ScheduleCardProps) {
  return (
    <article
      className="flex flex-col gap-2 rounded-lg border border-border p-3"
      data-status={schedule.status}
      aria-labelledby={`schedule-${schedule.id}-name`}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="font-semibold" id={`schedule-${schedule.id}-name`}>
          {schedule.name}
        </span>
        <Badge variant="secondary" aria-label={`Status: ${schedule.status}`} className="capitalize">
          {schedule.status}
        </Badge>
      </div>
      <code className="font-mono text-sm" aria-label="Cron expression">
        {formatCron(schedule.cron)}
      </code>
      <span className="text-sm text-muted-foreground">{formatNextRun(schedule.nextRunAt)}</span>
    </article>
  );
}
